import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LayoutDashboard, MessageSquareQuote, BookOpen, Scale, HelpCircle,
  FileStack, MessagesSquare, ClipboardCheck, History, LogOut, Inbox, ExternalLink,
} from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/admin/ask", label: "Ask Pramaana", icon: MessageSquareQuote, testid: "nav-ask" },
  { to: "/admin/review", label: "Review Queue", icon: Inbox, testid: "nav-review" },
  { to: "/admin/constitution", label: "Constitution", icon: BookOpen, testid: "nav-constitution" },
  { to: "/admin/decisions", label: "Decision Ledger", icon: Scale, testid: "nav-decisions" },
  { to: "/admin/open-questions", label: "Open Questions", icon: HelpCircle, testid: "nav-open-questions" },
  { to: "/admin/sources", label: "Sources", icon: FileStack, testid: "nav-sources" },
  { to: "/admin/conversations", label: "Conversations", icon: MessagesSquare, testid: "nav-conversations" },
  { to: "/admin/claims", label: "Claim Review", icon: ClipboardCheck, testid: "nav-claims" },
  { to: "/admin/history", label: "Knowledge History", icon: History, testid: "nav-history" },
];

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-[#FAFAFA]">
      <aside className="w-64 shrink-0 bg-[#0F172A] text-slate-100 flex flex-col fixed h-screen" data-testid="sidebar">
        <div className="px-6 py-7 border-b border-white/10">
          <div className="font-serif text-2xl tracking-tight text-white leading-none">Pramaana</div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 mt-2">Founder Intelligence</div>
          <Link to="/" data-testid="back-to-public" className="mt-4 inline-flex items-center gap-1.5 text-[11px] text-slate-400 hover:text-white transition-colors">
            <ExternalLink size={12} /> Public verification product
          </Link>
        </div>
        <nav className="flex-1 py-4 overflow-y-auto">
          {NAV.map(({ to, label, icon: Icon, testid, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-2.5 text-sm transition-colors duration-150 border-l-2 ${
                  isActive
                    ? "bg-white/5 border-white text-white"
                    : "border-transparent text-slate-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <Icon size={17} strokeWidth={1.5} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 px-6 py-4">
          <div className="text-xs text-slate-400 truncate mb-2" data-testid="current-user">{user?.email}</div>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors duration-150"
          >
            <LogOut size={15} strokeWidth={1.5} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 min-h-screen">{children}</main>
    </div>
  );
}

export function PageHeader({ title, subtitle, right }) {
  return (
    <div className="flex items-end justify-between border-b border-slate-200 bg-white px-10 py-7">
      <div>
        <h1 className="font-serif text-4xl tracking-tight text-slate-900 leading-none">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}
